/**
 * variant-media-groups.js — Galerie par variante (plages de positions)
 * -------------------------------------------------------------------------
 * La galerie produit est rendue en groupes `.mutil_slider-single` (un par photo
 * de variante, snippets/product-media.liquid) : chaque groupe contient les
 * photos communes (avant la première photo de variante) puis la plage allant de
 * la photo de la variante à celle précédant la photo d'une autre variante.
 * Ce module bascule la classe `.active` sur le bon groupe (clé data-media-group
 * = id du featured_media de la variante, ou "all" pour une variante sans photo).
 *
 * Contrat avec wpbingo.js (minifié) :
 *   - `_onSelectChange` déclenche `variantChange` (variant possiblement
 *     undefined) AVANT `_updateMedia` (qui émet `variantMediaChange`) et AVANT
 *     `_updateLabelvariant` (qui retire `.active` de tous les
 *     `.mutil_slider-single` sans rien ré-ajouter à nos groupes — son critère,
 *     classe = valeur d'option, ne matche plus). D'où la bascule différée en
 *     microtask : planifiée pendant le dispatch de `variantChange`, exécutée
 *     après tout le `_onSelectChange` synchrone, avant le paint (pas de flash).
 *   - Le handler stock de `variantMediaChange` (showVariantMedia) fait un
 *     `prependTo` destructeur en multi-groupes (il cible tous les groupes) : il
 *     est neutralisé par `.off('variantMediaChange')` sur le conteneur de
 *     section ([data-section-type="product-template"]). Le `.off()` est refait
 *     à CHAQUE `variantChange` (toujours après le bind wpbingo, et avant
 *     l'émission de `variantMediaChange` dans le même `_onSelectChange`), ce
 *     qui couvre toute ré-initialisation de la section (theme editor).
 *   - ⚠️ Chargement : OBLIGATOIREMENT depuis snippets/footer-javascript.liquid,
 *     APRÈS jquery-3.5.1.min.js. jQuery est chargé deux fois (header + footer) ;
 *     un script exécuté avant le rechargement du footer s'abonne sur la
 *     PREMIÈRE instance et ne reçoit jamais les événements custom déclenchés
 *     par wpbingo via la seconde (registres jQuery distincts).
 *   - Les événements `mediaHidden`/`mediaVisible` (pause des vidéos/modèles 3D,
 *     émis par triggerMediaChangeEvent, perdu avec le .off) sont répliqués ici.
 *
 * Sur un produit sans photos de variante, le markup multi-groupes n'existe pas
 * et ce module ne touche à rien (comportement stock intégralement conservé).
 * Dépendance : jQuery (chargé par footer-javascript.liquid).
 */
(function ($) {
  'use strict';

  if (!$) { return; }
  if (window.__variantMediaGroupsInit) { return; }
  window.__variantMediaGroupsInit = true;

  var GROUP_SELECTOR = '.mutil_slider-single[data-media-group]';

  function getContainer() {
    return document.querySelector('[data-section-type="product-template"]');
  }

  function getGroups(container) {
    return $(container).find(GROUP_SELECTOR);
  }

  // Réplique triggerMediaChangeEvent (wpbingo.js) : pause les vidéos/modèles 3D
  // des groupes cachés, réveille le média ancre du groupe actif.
  function triggerMediaEvents(container, $activeGroup, mediaId) {
    $(container).find('.js-product-media').trigger('mediaHidden');
    if (mediaId) {
      var sectionId = container.getAttribute('data-section-id');
      $activeGroup
        .find('.js-product-media[data-media-id="' + sectionId + '-' + mediaId + '"]')
        .trigger('mediaVisible');
    }
  }

  // Active le groupe `key` ("all" ou id de featured_media) ; mediaId = id de la
  // photo ancre pour le feedback slick mobile (null pour le groupe "all").
  function activateGroup(key, mediaId) {
    var container = getContainer();
    if (!container) { return; }
    var $groups = getGroups(container);
    if (!$groups.length) { return; }

    var $target = $groups.filter('[data-media-group="' + key + '"]');
    if (!$target.length) { $target = $groups.filter('[data-media-group="all"]'); }
    if (!$target.length) { $target = $groups.first(); }

    $groups.not($target).removeClass('active');
    $target.addClass('active');
    triggerMediaEvents(container, $target, mediaId);

    // Mobile : le slider slick du groupe a été initialisé dans un conteneur
    // caché → recalcul des dimensions, puis retour à la slide de la photo ancre
    // (les photos communes étant en tête de groupe).
    var $slider = $target.find('.js-product-media-group');
    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('setPosition');
      var index = 0;
      if (mediaId) {
        var sectionId = container.getAttribute('data-section-id');
        var $anchor = $slider.find('.js-product-media[data-media-id="' + sectionId + '-' + mediaId + '"]');
        var slickIndex = $anchor.closest('.slick-slide').data('slick-index');
        if (typeof slickIndex === 'number') { index = slickIndex; }
      }
      $slider.slick('slickGoTo', index, true);
    }
  }

  // L'événement `variantChange` est déclenché par wpbingo.Variants sur son
  // conteneur et remonte jusqu'au document ; il porte la variante sélectionnée.
  $(document).on('variantChange', function (e) {
    var container = getContainer();
    if (!container) { return; }
    if (!getGroups(container).length) { return; }

    // Neutralise showVariantMedia (prependTo destructeur) — idempotent, et
    // garanti APRÈS le bind wpbingo puisque déclenché par wpbingo lui-même.
    $(container).off('variantMediaChange');

    // Combinaison d'options indisponible : galerie inchangée (comme le stock).
    if (!e || !e.variant) { return; }

    var mediaId = e.variant.featured_media ? String(e.variant.featured_media.id) : null;
    var key = mediaId || 'all';
    var run = function () { activateGroup(key, mediaId); };
    if (window.queueMicrotask) { queueMicrotask(run); } else { Promise.resolve().then(run); }
  });

  function init() {
    var container = getContainer();
    if (!container || !getGroups(container).length) { return; }
    // Probable no-op (wpbingo, defer footer, n'a pas encore bindé) mais couvre
    // le theme editor où la section est ré-instanciée après coup.
    $(container).off('variantMediaChange');
  }

  // Theme editor : section ré-rendue puis ré-initialisée par wpbingo.
  $(document).on('shopify:section:load', init);

  // `defer` garantit le DOM prêt, mais on protège le cas d'un chargement précoce.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})(window.jQuery);
